// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { InteractionAuthorizationBaseService } from './interaction-authorization-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class InteractionAuthorizationMockService extends InteractionAuthorizationBaseService {
  override validateInteractionToken(id: string): void {
    throw new Error('Method not implemented.');
  }
}
